import { render, staticRenderFns } from "./specialty.vue?vue&type=template&id=473b326e&scoped=true"
import script from "./specialty.vue?vue&type=script&lang=js"
export * from "./specialty.vue?vue&type=script&lang=js"
import style0 from "./specialty.vue?vue&type=style&index=0&id=473b326e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b326e",
  null
  
)

export default component.exports